<template>
  <div class="PackingTabs">
    <el-tabs type="card" v-model="activeName" @tab-click="handleClick" v-if="detail.tab_count">
      <el-tab-pane :label="'未装完' + `(${detail.tab_count[0].num})`" name="1"></el-tab-pane>
      <el-tab-pane :label="'已装完' + `(${detail.tab_count[1].num})`" name="2"></el-tab-pane>
      <el-tab-pane :label="'全部' + `(${detail.tab_count[2].num})`" name="0"></el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      activeName: localStorage.getItem('japanUserRoleStatus') == 5 ? '1' : ''
    };
  },

  computed: {
    ...mapState({
      detail: (state) => state.porderDetail.detail,
    }),
  },
  methods: {
    handleClick() {
      let datas = {
        porder_sn: this.$route.query.porder_sn, //配送单号
        filterByFreightNum: this.activeName
      }
      this.$store.dispatch('porderDetailStatus', datas)

    },
  }
}
</script>
<style lang='scss' scoped>
.PackingTabs {

  margin: 24px 24px -12px;
}
</style>